module.exports = __webpack_public_path__ + "img/btn_bnr_arr_next.ccac220e.svg";